import debounce from 'lodash/debounce'
import useSearchStore from '../stores/useSearchStore'

const Search = ({searchPlaceholder, disabled}) => {
    const {setSearchString, searchInputString, setSearchInputString} = useSearchStore()

    return (
        <div className='mtt-dealer-search'>
            <div className='mtt-dealer-search__input-wrap'>
                <svg className='search-icon' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' width='20' height='20' fill='currentColor'>
                    <path d='M8.289 0A8.289 8.289 0 1 1 0 8.289 8.3 8.3 0 0 1 8.289 0Zm0 15.4a7.1125 7.1125 0 0 0 0-14.225 7.1125 7.1125 0 0 0 0 14.225Z'/>
                    <path d='M19.412 19.996a.586.586 0 0 1-.416-.168l-5.378-5.378a.588.588 0 0 1 0-.832.588.588 0 0 1 .832 0l5.378 5.378a.588.588 0 0 1-.416 1Z'/>
                </svg>
                <input
                    type='text'
                    placeholder={searchPlaceholder}
                    onChange={event => setSearchInputString(event.target.value)}
                    onKeyUp={debounce(event => setSearchString(event.target.value), 500)}
                    value={searchInputString}
                    disabled={disabled}
                />
            </div>
        </div>
    )
}

export default Search
